import { Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';

import { RoutesFacade, RouteSearchFacade } from '@ridango/components';
import { keyCode, ListService } from '@ridango/core';

import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'rwidget-schedule-search',
    templateUrl: './schedule-search.component.html',
    styleUrls: ['./schedule-search.component.scss'],
})
export class ScheduleSearchComponent implements OnInit, OnDestroy {
    private componentDestroyed$ = new Subject();
    private selectedIndex = 0;

    searchTermChanged$ = new Subject<string>();
    allRoutes$ = this.routes.allRoutes$;

    searchResults = [];
    previousSearch = [];
    hasNoResult = false;

    @ViewChildren('listItem') listItems: QueryList<ElementRef>;

    constructor(
        private routes: RoutesFacade,
        private routeSearch: RouteSearchFacade,
        private listService: ListService
    ) {}

    ngOnInit() {
        this.searchTermChanged$
            .pipe(debounceTime(500), distinctUntilChanged(), takeUntil(this.componentDestroyed$))
            .subscribe((searchKey) => {
                this.searchResults = this.routeSearch.findRoute(searchKey);
                this.hasNoResult = searchKey.length > 0 && this.searchResults.length === 0;
            });

        this.routeSearch.previousSearch$
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((previousSearch) => (this.previousSearch = previousSearch));
    }

    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }

    changed(event: KeyboardEvent) {
        const target = event.target as HTMLInputElement;
        const searchTerm = target.value.trim();
        this.searchTermChanged$.next(searchTerm);
    }

    setPrevious(routeId: string) {
        this.routeSearch.setPreviousSearchRoute(routeId);
    }

    setFocusOnNextItem(event: KeyboardEvent, listSize: number) {
        switch (event.keyCode) {
            case keyCode.ARROW_DOWN:
                event.preventDefault();
                this.selectNextItem(1, listSize);
                break;
            case keyCode.ARROW_UP:
                event.preventDefault();
                this.selectNextItem(-1, listSize);
                break;
        }
    }

    private selectNextItem(direction: number, listSize): void {
        this.selectedIndex = this.listService.getNextCyclicIndex(this.selectedIndex, direction, listSize);
        setTimeout(() => this.listItems.toArray()[this.selectedIndex].nativeElement.focus());
    }
}
